<div class="tab-large-group" [class]="width">
  <div
    class="tab-background"
    [style.transform]="'translateX(' + backgroundX + 'px)'"
    [style.width.px]="backgroundWidth"
  ></div>
  @for (tab of tabs; track $index) {
    <button
      #tabBtn
      type="button"
      class="tab-large"
      [class.active]="selectedIndex === $index"
      [class]="paddingSize"
      (click)="selectTab($index)"
    >
      @if (translateTabs) {
        {{ tab | translate }}
      } @else {
        {{ tab }}
      }
    </button>
  }
</div>
